module.exports = __webpack_public_path__ + "img/manual-despre-superioritatea-ierusalimului-1728-pagina-de-titlu-big.dd4eba64.jpg";